export class ConnectionError extends Error {
  code?: string;

  constructor() {
    super('Erro de conexão.');
    this.name = 'ConnectionError';
  }
}
